import { Grid, GridColumn, GridRow } from '@bp/ui-components';
import { graphql } from 'client/gql';
import { BpCard } from 'components/BpCard/BpCard';
import { BpSubpage } from 'components/BpSubpage/BpSubpage';
import { RunningMeetingsTable } from 'components/RunningMeetingsTable/RunningMeetingsTable';
import dayjs from 'dayjs';
import { useAuthClaims } from 'hooks/useAuthClaims';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'urql';
import styles from './RunningBBBMeetingsSubpage.module.scss';

const RunningZoomMeetingsSubpagePageQueryDocument = graphql(`
  query RunningZoomMeetingsSubpagePageData($calendarEventWhere: CalendarEventWhere!) {
    ...RunningMeetingsTableFields
  }
`);

export const RunningZoomMeetingsSubpage = () => {
  const { t } = useTranslation();
  const organizationUuid = useAuthClaims().pimAuthClaims.getOrganizationUuid();

  const [{ data }, refetch] = useQuery({
    query: RunningZoomMeetingsSubpagePageQueryDocument,
    variables: {
      calendarEventWhere: {
        start_CONTAINS: dayjs().startOf('day').format('YYYY-MM-DD'),
        organization: { uuid: organizationUuid },
        categories: ['zoom'],
      },
    },
  });

  return (
    <BpSubpage>
      <Grid className={styles['running-zoom-meetings']}>
        <GridRow mobileGap='var(--grid-row-gap)'>
          <GridColumn width={6}>
            <BpCard>
              <div className={styles.text}>{t('meetings.currentlyRunning')}</div>
              <div className={styles.count}>9999</div>
            </BpCard>
          </GridColumn>
          <GridColumn width={6}>
            <BpCard>
              <div className={styles.text}>{t('meetings.licensedUsers')}</div>
              <div className={styles.count}>9999</div>
            </BpCard>
          </GridColumn>
        </GridRow>
        <GridRow>
          <BpCard header={{ headline: t('meetings.runningMeetings') }} noPadding>
            <RunningMeetingsTable
              query={data}
              type='zoom'
              onRefetch={() => refetch({ requestPolicy: 'network-only' })}
            />
          </BpCard>
        </GridRow>
      </Grid>
    </BpSubpage>
  );
};
